<template>
    <b-modal scrollable ref="mdlTeamsystemintegrator" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" @ok="onOk">
        <div style="height: 100%">
            <div class="sa-flexbox" style="padding-bottom: 20px">
                <div class="sa-flexbox-header">
                    <b-row v-if="!editTestata">
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Documento</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.tipoDocumento }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.codiceFiscale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Ragione Sociale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.ragioneSociale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Città</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.citta }} ({{ jsonDataFattura.Testata.provincia }})</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Cap</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.cap }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Indirizzo</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.indirizzo }}</span>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Documento</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.tipoDocumento }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale</label>
                            <b-form-input maxlength="16" class="text-uppercase" v-model="jsonDataFattura.Testata.codiceFiscale"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Ragione Sociale</label>
                            <b-form-input v-model="jsonDataFattura.Testata.ragioneSociale"></b-form-input>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Provincia</label>
                            <b-form-select v-model="jsonDataFattura.Testata.provincia" :options="provinceOptions" value-field="value" text-field="text" @change="onChangeProvincia">
                                <template #first>
                                    <b-form-select-option value="" disabled>- Seleziona Provincia -</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Città</label>
                            <b-form-select v-model="jsonDataFattura.Testata.citta" :options="comuniOptions" value-field="codiceIstat" text-field="comune" @change="setCap">
                                <template #first>
                                    <b-form-select-option value="" disabled>- Seleziona Città -</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Cap</label>
                            <b-form-input v-model="jsonDataFattura.Testata.cap"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Indirizzo</label>
                            <b-form-input maxlength="16" class="text-uppercase" v-model="jsonDataFattura.Testata.indirizzo"></b-form-input>
                        </b-col>
                    </b-row>
                </div>

                <div class="sa-flexbox-body">
                    <div class="b-table-sticky-header">
                        <b-table scrollable head-variant="light" class="sa-b-table" sticky-header ref="table" stacked="lg" striped hover :items="jsonDataFattura.Corpo" :fields="fields" sort-icon-left>
                            <template #cell(index)="row">
                                <span> {{ row.index + 1 }} </span>
                            </template>
                            <template v-slot:cell(articolo)="row">
                                <span v-if="row.index != jsonDataFattura.Corpo.length - 1">{{ row.item.descrizione }} ({{ row.item.codiceArticolo }})</span>
                                <b-form-select v-else v-model="row.item.codiceArticolo" class="mb-2 mr-sm-2 mb-sm-0" :options="prodottiOptions" :value="''" text-field="name" value-field="_id" @change="onchangeProdotto(row.item)"> </b-form-select>
                            </template>
                            <template v-slot:cell(quantita)="{ item }">
                                <b-form-input v-model="item.quantita" @input="onChangeValue(item)"></b-form-input>
                            </template>
                            <template v-slot:cell(aliquotaIva)="{ item }">
                                <b-form-select v-model="item.aliquotaIva" class="mb-2 mr-sm-2 mb-sm-0" :options="ivaOptions" :value="''" text-field="descrizione" value-field="aliquota"> </b-form-select>
                            </template>
                            <template v-slot:cell(prezzoUnitario)="{ item }">
                                <b-form-input v-model="item.prezzoUnitario" @input="onChangeValue(item)"></b-form-input>
                            </template>
                            <template #cell(actions)="row">
                                <b-container class="bv-example-row">
                                    <b-button v-if="row.index == jsonDataFattura.Corpo.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAddRiga(jsonDataFattura.Corpo, row.item)">
                                        <b-icon icon="plus"></b-icon>
                                    </b-button>
                                </b-container>
                            </template>
                        </b-table>
                    </div>
                </div>
                <div class="sa-flexbox-footer">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                            <label class="sa-label-data">Totale:</label>
                            <span class="sa-data">{{ totaleDocuemnto }}</span>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/teamsystemintegratorresponse",
            pathResourceIva: "/teamsystemintegratoriva",
            pathResourceProdotti: "/externalprenotazioni/listaprodotti",
            pathResourcePrezzi: "/externalprenotazioni/prezzo",
            // NUOVI PATH RICHIESTI
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",

            title: "Modifica Fattura",
            ivaOptions: [],
            prodottiOptions: [],
            provinceOptions: [],
            comuniOptions: [],
            editTestata: false,
            jsonData: {},
            rigaSelezionata: {},
            totaleDocuemnto: 0,
            jsonDataFattura: { Testata: {}, Corpo: [] },
            fields: [
                { label: "*", key: "index", thStyle: "width: 0.5rem" },
                { label: "Articolo", key: "articolo" },
                { label: "Iva", key: "aliquotaIva", thStyle: "width: 20rem" },
                { label: "Quantita", key: "quantita", thStyle: "width: 5rem" },
                { label: "U.M.", key: "unitaMisura", thStyle: "width: 5rem" },
                { label: "Prezzo Unitario", key: "prezzoUnitario", thStyle: "width: 10rem" },
                { label: "Totale", key: "importoTotale", thStyle: "width: 10rem" },
                { key: "actions", label: "" },
            ],
        };
    },
    methods: {
        init(id) {
            let me = this;
            me.id = id;

            if (me.id === null) {
                me.$emit("afterLoadData");
                me.editTestata = true;
                me.jsonDataFattura.Testata = { tipoDocumento: "3", serieBolla: "0", numeroBolla: "0", codiceCliente: "0", ragioneSociale: "", indirizzo: "", cap: "", citta: "", provincia: "", codiceFiscale: "", partitaIva: "0", codicePagamento: "301", codiceAgente: "0", codiceDeposito: "0", codiceBanca: "0", codiceAgenzia: "0", dataBolla: null, tipoIva: "0", causaleTrasporto: "1", vettore: "0", totaleColli: "1" };
                me.jsonDataFattura.Corpo.push({ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0" });
                this.$refs.mdlTeamsystemintegrator.show();
            } else {
                me.editTestata = false;
                me.$emit("beforeLoadData");
                me.loadData();
            }
            this.$emit("afterLoadData");
            me.loadIva();
            me.loadProdotti();
            me.loadProvince(); // Carica l'elenco province all'avvio
        },

        // CARICAMENTO PROVINCE
        loadProvince() {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                me.pathResourceProvince + "?language=it",
                null,
                (response) => {
                    response.data.data.forEach((element) => {
                        me.provinceOptions.push({ value: element.sigla, text: element.provincia });
                    });
                },
                (err) => console.error(err),
            );
        },

        // GESTIONE CAMBIO PROVINCIA -> CARICAMENTO COMUNI
        onChangeProvincia() {
            let me = this;
            let sigla = me.jsonDataFattura.Testata.provincia;
            me.jsonDataFattura.Testata.citta = ""; // Reset città
            if (sigla) {
                me.loadComuni(sigla);
            } else {
                me.comuniOptions = [];
            }
        },

        loadComuni(siglaProvincia) {
            let me = this;
            // Chiamata all'endpoint linkComune concatenando la sigla
            let link = me.pathResourceComuni + "/" + siglaProvincia;
            UtilityMixin.methods.loadDataResources(
                link,
                null,
                (res) => {
                    me.comuniOptions = res.data.data.list || res.data.data;
                },
                (err) => console.error(err),
            );
        },

        loadData() {
            let me = this;
            let link = me.pathResource + "/" + me.id;
            UtilityMixin.methods.loadDataResources(link, null, me.loadDataSuccess, me.loadDataError);
        },

        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonDataFattura = JSON.parse(me.jsonData.body);
            me.jsonDataFattura.Corpo.push({ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0" });

            // Se in fase di modifica ho già una provincia salvata, carico i comuni per popolare la select
            if (me.jsonDataFattura.Testata.provincia) {
                me.loadComuni(me.jsonDataFattura.Testata.provincia);
            }

            me.$emit("afterLoadData");
            me.calcolaTotale();
            this.$refs.mdlTeamsystemintegrator.show();
        },

        // Resto della logica (IVA, Prodotti, Salvataggio, Calcoli) invariata...
        loadDataError(error) {
            error;
            this.$emit("afterLoadData");
        },
        loadIva() {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                me.pathResourceIva,
                null,
                (res) => {
                    me.ivaOptions = res.data.data.list;
                    me.ivaOptions.unshift({ aliquota: "", descrizione: "-Seleziona Valore-" });
                },
                (err) => {
                    err;
                },
            );
        },
        loadProdotti() {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                me.pathResourceProdotti,
                null,
                (res) => {
                    me.prodottiOptions = res.data.data.products;
                    me.prodottiOptions.push({ _id: "0", name: "Acconto Versato" });
                    me.prodottiOptions.unshift({ _id: "", name: "-Seleziona Valore-" });
                },
                (err) => {
                    err;
                },
            );
        },
        onOk() {
            let me = this;
            if (me.editTestata) {
                me.jsonData.idEvento = "";
                me.jsonData.response = "";
                me.jsonData.status = "";
                me.jsonData.dataOra = new Date().getTime();
                me.jsonData.statoAttualeDataOra = new Date().getTime();
                me.jsonData.statoAttuale = "DA INVIARE";
            }
            let corpo = [];
            me.jsonDataFattura.Corpo.forEach((element) => {
                if (element.codiceArticolo !== "") corpo.push(element);
            });
            me.jsonDataFattura.Corpo = corpo;
            me.jsonData.body = JSON.stringify(me.jsonDataFattura);
            me.saveResource(
                this.pathResource,
                this.jsonData,
                () => me.$emit("afterSave"),
                (err) => {
                    err;
                },
            );
        },
        onChangeValue(item) {
            const qta = parseFloat(String(item.quantita).replace(",", ".")) || 0;
            const prezzo = parseFloat(String(item.prezzoUnitario).replace(",", ".")) || 0;
            item.importoTotale = (qta * prezzo).toFixed(2).replace(".", ",");
            this.calcolaTotale();
        },
        calcolaTotale() {
            let me = this;
            me.totaleDocuemnto = 0;
            me.jsonDataFattura.Corpo.forEach((element) => {
                me.totaleDocuemnto += parseFloat(String(element.importoTotale).replace(",", ".")) || 0;
            });
        },
        onAddRiga(array, value) {
            if (value.descrizione !== "") {
                array.push({ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0" });
            } else {
                this.$bvModal.msgBoxOk("Dati non validi!", { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", centered: true });
            }
        },
        onchangeProdotto(item) {
            let me = this;
            me.prodottiOptions.forEach((element) => {
                if (element._id === item.codiceArticolo) {
                    item.descrizione = element.name;
                    me.rigaSelezionata = item;
                    me.getPrezzoArticolo(item.codiceArticolo);
                }
            });
        },
        getPrezzoArticolo(codiceArticolo) {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                this.pathResourcePrezzi + "/" + codiceArticolo,
                null,
                (res) => {
                    me.rigaSelezionata.prezzoUnitario = res.data.data.amount;
                },
                (err) => {
                    err;
                },
            );
        },
        onClickCodiceFiscale(identificativo) {
            this.loadDataResources(
                "/utilityanagrafica/codicefiscale",
                { codiceFiscale: identificativo.toUpperCase() },
                (res) => {
                    console.log(res.data.data);
                },
                (err) => {
                    this.$bvToast.toast("Errore: " + (err.response.data.messaggio || ""), { title: "Errore", variant: "danger", solid: true });
                },
            );
        },
        setCap(value) {
            let me = this;
            console.log(value);

            me.comuniOptions.forEach((comune) => {
                if (comune.codiceIstat === value) {
                    me.jsonDataFattura.Testata.cap = comune.cap;
                }
            });
        },
    },
};
</script>
